/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputContent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaInputContent({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputContent",
  placeholder,
  backgroundColor,
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  borderTopLeftRadius = 4,
  borderTopRightRadius = 4,
  borderWidth = 1,
  borderColor,
  paddingLeft = 12,
  paddingRight = 12,
  paddingTop = 5,
  paddingBottom = 5,
  maxWidth,
  size,
  dock,
  disabled,
  focused,
  invalid,
  type,
  hovered,
  valid,
  value,
  min,
  max,
  step,
  autoFocus,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  mousetrap,
  disableFuture,
  dateFuture,
  disablePast,
  datePast,
  yearPicker,
  onKeyUp
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtTysiainputcontentBackgroundcolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.backgroundColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryFocused = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.focused'
        })
let dtTysiainputcontentBordercolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.invalid'
        })
let backgroundColorOrdtColorsWhite = backgroundColor ?? dtColorsWhite
let borderColorOrdtColorsNeutral300 = borderColor ?? dtColorsNeutral300
  return (<React.Fragment
>
<div
  data-testid="TysiaInputContent.Horizontal"
  data-view-path={viewPath}
 placeholder={placeholder}
 style={{'--bw-6-ZekR7N': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--mw-13-ZekR7N': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--h-8-ZekR7N': size === "small" ? "24px" : "30px",'--pt-11-ZekR7N': size === "small" ? "4px" : typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-12-ZekR7N': size === "small" ? "4px" : typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-9-ZekR7N': size === "small" ? "12px" : typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-10-ZekR7N': size === "small" ? "12px" : typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--bblr-2-ZekR7N': dock === "left" ? "0px" : typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--btlr-4-ZekR7N': dock === "left" ? "0px" : typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--bbrr-3-ZekR7N': dock === "right" ? "0px" : typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btrr-5-ZekR7N': dock === "right" ? "0px" : typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bc-1-ZekR7N': disabled ? dtTysiainputcontentBackgroundcolorPrimaryDisabled : backgroundColorOrdtColorsWhite,'--bc-7-ZekR7N': disabled ? dtTysiainputcontentBordercolorPrimaryDisabled : focused ? dtTysiainputcontentBordercolorPrimaryFocused : invalid ? dtTysiainputcontentBordercolorPrimaryInvalid : borderColorOrdtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 placeholder={placeholder}
 type={type}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 value={value}
 min={min}
 max={max}
 step={step}
 autoFocus={autoFocus}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 mousetrap={mousetrap}
 disableFuture={disableFuture}
 dateFuture={dateFuture}
 disablePast={disablePast}
 datePast={datePast}
 yearPicker={yearPicker}
 onKeyUp={onKeyUp}
>
{children}
</Children>
</div>
</React.Fragment>)
}